/**
 * Locale constants
 */

// Defaults
export const DEFAULT_LOCALE = 'en-AU'
